// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"285b2c2a","522":"1480ae92","838":"4e33bcfc","953":"e7ce0f9f"}[chunkId] + ".chunk.js";
};